import { Link } from 'react-router-dom'
import { MessageCirclePlus, History } from 'lucide-react'
import { cn } from '../../lib/utils'
import logo from '../../logo.png'
import ChatHistory from './ChatHistory';
import { useEffect, useState } from 'react';


interface SidebarProps {
  isMobileOpen: boolean;
  setIsMobileOpen: (open: boolean) => void;
}

export default function UserSidebar({ isMobileOpen, setIsMobileOpen }: SidebarProps) {
  const [showHistory, setShowHistory] = useState(false)
  
  useEffect(() => {
    setShowHistory(true)
  }, [])

  return (
    <>
      {/* Desktop Sidebar */}
      <aside className="w-64 hidden md:flex flex-col bg-gray-900 text-white h-screen sticky top-0 shadow-md">
        <div className="p-4 font-bold border-b border-gray-700">
        <img src={logo} alt="Logo" className="w-1/2 bg-white m-auto" />
        </div>
        <nav className="flex flex-col gap-1 mt-4 user-sidebar-text  max-h-[calc(90vh-64px)] overflow-y-auto relative">
          <div className='sticky top-0 z-10 '>
            <Link
              key={1}
              to={'/research'}
              className={cn(
                'flex items-center gap-1 px-4 py-2 hover:bg-gray-800 transition text-base font-bold',
              
              )}
            >
              <MessageCirclePlus size={18} />
              New Chat
            </Link>
          </div>

          {showHistory && (
            <>
            <div className="flex  border-b border-gray-700 pb-1 w-full chat-history-container">
              <h2 className="flex items-center gap-1 px-4 py-2 text-base font-bold">
                <History size={18} /> History
              </h2>
            </div>
            <div className=' flex w-full relative overflow-y-auto flex-col user-sidebar-scroller'>
              
              <ChatHistory />
            </div>
            </>
          )}
        </nav>
      </aside>

      {/* Mobile Sidebar */}
      {isMobileOpen && (
        <div className="fixed inset-0 z-50 flex md:hidden">
          <div className="w-64 bg-gray-900 text-white flex flex-col shadow-lg">
            <div className="p-4 text-sm font-bold border-b border-gray-700">
            <img src={logo} alt="Logo" className="h-10 mb-2" />
            </div>
            <nav className="flex flex-col gap-1 mt-4 text-sm max-h-[calc(90vh-64px)]">
              <Link
                key={1}
                to={'/research'}
                className={cn(
                  'flex items-center gap-1 px-4 py-2 hover:bg-gray-800 transition text-base font-bold',
                
                )}
                onClick={() => setIsMobileOpen(false)}
              >
                <MessageCirclePlus size={18} />
                New Chat
              </Link>

              {showHistory && (
                <>
                <div className="flex mt-3 border-b border-gray-700 pb-1 w-full">
                  <h2 className="flex items-center gap-1 px-4 py-2 text-base font-bold">
                    <History size={18} /> History
                  </h2>
                </div>
                <div className=' flex w-full relative overflow-y-auto flex-col' onClick={() => setIsMobileOpen(false)}>
                  <ChatHistory />
                </div>
                </>
              )}
            </nav>
          </div>
          <div className="flex-1 bg-black/40" onClick={() => setIsMobileOpen(false)}></div>
        </div>
      )}
    </>
  )
}